<template>
  <div v-if="show_gmbar">
    <v-chip
      v-if="ispassword"
      small color="grey" class="hidden-sm-and-down caption darken-1 text-uppercase" style="height:20px;"
    >
      <v-icon x-small left>mdi-monitor</v-icon>
      Active Machines: <strong>{{active_machines_count}}</strong>
    </v-chip>
    <v-btn 
      v-if="ispassword"
      rounded x-small color="orange" elevation=24 class="mx-1 px-1 caption"
      title="Change Service Plan" @click="edit_service_plan"
    >
        <v-icon x-small left class="mx-0">star</v-icon>
        Service Plan
        <span v-if="service_plan">
            <b>{{`: ${service_plan.name || service_plan}`}}</b>
        </span>
    </v-btn>
    <v-btn
      v-if="ispassword"
      rounded x-small :color="credits_available > 0 ? 'success' : 'error'" elevation="24" class="px-1 caption"
      title="Buy Credits" @click="show_payments"
    >
        <v-icon x-small left class="mx-0">credit_card</v-icon>
        Credits: <b>{{`${credits_available.toFixed(2)}`}}</b>
    </v-btn>
    <v-dialog v-model="service_plan_dialog" width="400" overlay-opacity="0.6">
      <v-form width="250" ref="change_service_plan" lazy-validation>
        <v-card width="100%">
          <v-alert v-if="service_plan_error" class="error my-0 pa-2" tile>
            <v-icon small class="pb-1">warning</v-icon>
            <span class="subtitle-1 font-weight-medium pl-2">{{service_plan_error}}</span>
          </v-alert>
          <v-btn class="float-right" fab dark small text @click="close_service_plan_dialog">
            <v-icon dark>mdi-close</v-icon>
          </v-btn>
          <v-card-title>
            <span class="subtitle-1 font-weight-medium grey darken-3 px-2">Update Service Plan</span>
          </v-card-title>
          <v-card-text class="py-0">
            <v-container class="pa-0">
              <v-row>
                <v-col class="py-0" cols="4">
                  <v-combobox
                    v-model="service_plan"
                    :items="service_plans || []"
                    label="Service Plan"
                    item-text="name"
                    item-value="name"
                    item-disabled="selected"
                    @change="service_plan_changed"
                  ></v-combobox>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" depressed x-small @click="update_service_plan()">Update</v-btn>
        </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "GMbar",
  props: {
    profile_details: {
      type: Object
    },
    load_profile: {
      type: Function
    }
  },
  data() {
    return {
      page_title : "",
      show_gmbar: false,
      service_plan: null,
      credits_available: 0,
      user_name: "",
      service_plans: [],
      service_plan_dialog: false,
      service_plan_error: null,
      ispassword: false,
      active_machines_count: 0
    }
  },
  methods: {
    show_profile (){
      this.$router.push('/profile');
    },
    show_payments() {
      this.$router.push('/payments');
    },
    close_service_plan_dialog() {
      this.service_plan_dialog = false;
      this.load_profile();
    },
    edit_service_plan() {
      this.service_plan_error = null;
      this.service_plan_dialog = true;
    },
    update_service_plan(){
      let post_json = {
        service_plan: this.service_plan.name || this.service_plan
      }
      axios.post(`https://${this.$buyerAPI}/accounts`, post_json)
      .then(() => {
        this.service_plan_dialog = false;
        setTimeout(()=>{
          this.load_profile();
        }, 500)
      })
      .catch(error => {
          if (error.response){
            this.service_plan_error = error.response.data.error;
          }else{
            this.service_plan_error = error.message;
          }
      })
    },
    service_plan_changed(){
      if (this.service_plan.name == "Rush +"){
        window.open("https://www.gridmarkets.com/rush-plus");

        if (this.profile_details.service_plan != "Rush"){
          this.service_plan = "Rush";
          this.update_service_plan();
        }else{
          this.service_plan_dialog = false;
          setTimeout(()=>{
            this.load_profile();
          }, 500)
        }
        return false;
      }
    }
  },
  computed : {
    userLoggedIn : function() { return this.$store.getters.userLoggedIn},
    isLoggedIn : function() {return this.$store.getters.isLoggedIn}
  },
  created () {
    this.page_title = this.$route.name;
    this.show_gmbar = ["login", "register"].indexOf(this.$route.name) > -1 ? false : true;

    if (this.userLoggedIn.ispassword){
      this.ispassword = true;
    }
    
    this.credits_available = this.profile_details && this.profile_details.credits_available || 0;
    this.active_machines_count = this.profile_details && this.profile_details.active_machines || 0;

    this.service_plan = this.profile_details && this.profile_details.service_plan || null;
    this.service_plans = this.profile_details && this.profile_details.service_plans || [];
    let rush_plan = {
        can_use: true,
        can_use_reason: "",
        name: "Rush +",
        selected: false
    }
    this.service_plans.push(rush_plan)
  }
}
</script>
<style>

</style>